// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import 'firebase/compat/storage';
import 'firebase/compat/firestore';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD2vFqrAjFhkZY7IXvSGqFv4I8bZdmXoCQ",
  authDomain: "fir-66b33.firebaseapp.com",
  projectId: "fir-66b33",
  storageBucket: "fir-66b33.appspot.com",
  messagingSenderId: "978441071050",
  appId: "1:978441071050:web:c58989b6d2451fb951c733"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };